import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import classNames from 'classnames';
import Settings from '../../containers/Settings';
import PaymentInfo from '../../containers/PaymentInfo';
import imgHeaderBg from '../../img/block-1-bg.png';
// translate
import messages from './messages';

class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.onChangeTab = this.onChangeTab.bind(this);

    this.state = { tab: 1 };
  }

  onChangeTab(tab) {
    this.setState({ tab });
  }

  render() {
    const { intl } = this.props;
    return (
      <div>
        <div
          className="container-fluid block-1 payments"
          style={{ backgroundImage: `url('${imgHeaderBg}')` }}
        >
          <div className="row">
            <div className="container">
              <div className="row">
                <p className="text-header">
                  <strong><FormattedHTMLMessage {...messages.header} /></strong>
                </p>
                <p className="text">
                  {intl.formatMessage(messages.description)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid block-2 payments">
          <div className="container">
            <div className="row">
              <div className="tabs-wrap">
                <ul className="tabs-header">
                  <li
                    className={classNames('col-md-3', {
                      active: this.state.tab === 1,
                    })}
                  >
                    <a
                      className="tabs-header-item trans"
                      role="button"
                      tabIndex="0"
                      onClick={() => {
                        this.onChangeTab(1);
                      }}
                    >
                      {intl.formatMessage(messages.settings)}
                    </a>
                  </li>
                  <li
                    className={classNames('col-md-3', {
                      active: this.state.tab === 2,
                    })}
                  >
                    <a
                      className="tabs-header-item trans"
                      role="button"
                      tabIndex="0"
                      onClick={() => {
                        this.onChangeTab(2);
                      }}
                    >
                      {intl.formatMessage(messages.paymentInfo)}
                    </a>
                  </li>
                </ul>

                <div className="tabs-body">
                  <div
                    className={classNames('col-xs-12 tab-item tab-1', {
                      active: this.state.tab === 1,
                    })}
                  >
                    <div className="payment-requisites-wrap popup-reg">
                      <p className="popup-header">
                        {intl.formatMessage(messages.settingsHeader)}
                      </p>
                      <div className="popup-body">
                        {this.state.tab === 1 && <Settings />}
                      </div>
                    </div>
                  </div>

                  <div
                    className={classNames('col-xs-12 tab-item tab-2', {
                      active: this.state.tab === 2,
                    })}
                  >
                    <div className="payment-requisites-wrap popup-reg">
                      <p className="popup-header">
                        {intl.formatMessage(messages.paymentInfoHeader)}
                      </p>
                      <div className="popup-body">
                        {this.state.tab === 2 && <PaymentInfo />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProfilePage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(ProfilePage);



// WEBPACK FOOTER //
// ./src/pages/ProfilePage/index.js